import React from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";

class About extends React.Component {
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-primary">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8" className="mx-auto text-center">
                      <h1 className="display-3 text-white">
                        About{" "}
                        <span>Chisp Technologies</span>
                      </h1>
                      <p className="lead text-white">
                        Founded with a mission to make AI monitoring accessible and effective 
                        for businesses and homes. We believe intelligent monitoring should be 
                        simple, private, and powerful.
                      </p>
                    </Col>
                  </Row>
                </div>
              </Container>
            </section>
          </div>

          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Card className="shadow border-0" style={{ background: 'linear-gradient(135deg, #232b4d 0%, #2d365f 100%)' }}>
                    <CardBody className="p-lg-5">
                      <Row className="align-items-center">
                        <Col lg="6">
                          <h3 className="text-white mb-2">Our Mission</h3>
                          <p className="text-white">
                            To democratize intelligent monitoring by providing AI-powered solutions 
                            that are both sophisticated and simple to use. We're bridging the gap 
                            between enterprise-grade monitoring systems and everyday users who need 
                            reliable, intelligent oversight of their spaces.
                          </p>
                          <h3 className="text-white mb-2 mt-4">Our Vision</h3>
                          <p className="text-white">
                            A world where intelligent monitoring prevents accidents, protects assets, 
                            and provides peace of mind without compromising privacy or requiring 
                            technical expertise.
                          </p>
                        </Col>
                        <Col lg="6">
                          <div className="text-center">
                            <img
                              alt="Chisp logo"
                              className="img-fluid"
                              src={require("assets/img/brand/chisp.png")}
                              style={{ width: "200px" }}
                            />
                            <h4 className="text-white mt-3">One Platform. Infinite Insight.</h4>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-team section-lg bg-gradient-default">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3 text-white">Meet our team</h2>
                  <p className="lead text-white">
                    A passionate team of engineers, designers, and innovators dedicated 
                    to making intelligent monitoring accessible to everyone.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="Jarret Ealy"
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/jarret.jpeg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title text-white">
                        <span className="d-block mb-1">Jarret Ealy</span>
                        <small className="h6 text-muted">Co-Founder & CEO</small>
                      </h5>
                      <div className="text-white">
                        <p className="mb-3">
                          With over a decade of experience in engineering sales and project management, 
                          Jarret brings a unique combination of technical expertise and business acumen to Chisp Technologies.
                        </p>
                        <div className="row">
                          <div className="col-md-6">
                            <h6 className="text-info mb-2">
                              <i className="fa fa-lightbulb mr-2"></i>
                              AI & Technical Expertise
                            </h6>
                            <ul className="list-unstyled text-sm">
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Artificial Intelligence & Machine Learning
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Technical Solutions Architecture
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Complex Problem Solving
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6">
                            <h6 className="text-info mb-2">
                              <i className="fa fa-users mr-2"></i>
                              Leadership & Management
                            </h6>
                            <ul className="list-unstyled text-sm">
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Stakeholder Alignment
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Project Management
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Strategic Planning
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <Button
                          className="about-social-icon btn-icon-only btn-round"
                          href="https://www.linkedin.com/in/jarretealy/"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="lg"
                        >
                          <i className="fa fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="Adam Heimowitz"
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/adam.jpeg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title text-white">
                        <span className="d-block mb-1">Adam Heimowitz</span>
                        <small className="h6 text-muted">Co-Founder & CTO</small>
                      </h5>
                      <div className="text-white">
                        <p className="mb-3">
                          Adam is a seasoned cloud architect and engineering leader with extensive experience 
                          in building scalable, distributed systems across multiple cloud platforms.
                        </p>
                        <div className="row">
                          <div className="col-md-6">
                            <h6 className="text-primary mb-2">
                              <i className="fa fa-cloud mr-2"></i>
                              Cloud Architecture
                            </h6>
                            <ul className="list-unstyled text-sm">
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Scalable Distributed Systems
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Microservices Architecture
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                DevOps & CI/CD
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6">
                            <h6 className="text-primary mb-2">
                              <i className="fa fa-cogs mr-2"></i>
                              Engineering Leadership
                            </h6>
                            <ul className="list-unstyled text-sm">
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Cross-functional Team Leadership
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Code Quality & System Reliability
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Innovation & Problem-Solving
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <Button
                          className="about-social-icon btn-icon-only btn-round"
                          href="https://www.linkedin.com/in/adamheimowitz/"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="lg"
                        >
                          <i className="fa fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="Craig Wilkinson"
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/craig.jpeg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title text-white">
                        <span className="d-block mb-1">Craig Wilkinson</span>
                        <small className="h6 text-muted">Co-Founder & COO</small>
                      </h5>
                      <div className="text-white">
                        <p className="mb-3">
                          Craig is a versatile technical innovator who specializes in rapid prototyping and 
                          technical feasibility analysis, serving as the critical bridge between business vision and engineering implementation.
                        </p>
                        <div className="row">
                          <div className="col-md-6">
                            <h6 className="text-warning mb-2">
                              <i className="fa fa-lightbulb-o mr-2"></i>
                              Innovation & Prototyping
                            </h6>
                            <ul className="list-unstyled text-sm">
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Rapid Prototyping
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Technical Feasibility Analysis
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Proof-of-Concept Development
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6">
                            <h6 className="text-warning mb-2">
                              <i className="fa fa-map mr-2"></i>
                              Technical Strategy
                            </h6>
                            <ul className="list-unstyled text-sm">
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Customer Requirements Translation
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Engineering Roadmap Development
                              </li>
                              <li className="py-1">
                                <i className="fa fa-check text-success mr-2"></i>
                                Architectural Foundation Design
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <Button
                          className="about-social-icon btn-icon-only btn-round"
                          href="https://www.linkedin.com/in/craig-wilkinson-b3429078/"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="lg"
                        >
                          <i className="fa fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">Our Values</h2>
                  <p className="lead text-muted">
                    The principles that guide everything we do at Chisp Technologies.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="4">
                  <Card className=" shadow border-0">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                        <i className="fa fa-lock" />
                      </div>
                      <h6 className="text-primary text-uppercase">
                        Privacy First
                      </h6>
                      <p className="description mt-3">
                        We believe your data belongs to you. Our systems are designed 
                        with privacy at their core, ensuring your information stays secure and private.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className=" shadow border-0">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                        <i className="fa fa-lightbulb-o" />
                      </div>
                      <h6 className="text-success text-uppercase">
                        Innovation
                      </h6>
                      <p className="description mt-3">
                        We're constantly pushing the boundaries of what's possible with AI 
                        monitoring, creating solutions that are both cutting-edge and practical.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className=" shadow border-0">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                        <i className="fa fa-heart" />
                      </div>
                      <h6 className="text-warning text-uppercase">
                        Simplicity
                      </h6>
                      <p className="description mt-3">
                        Complex technology should be simple to use. We focus on creating 
                        intuitive experiences that anyone can master.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg bg-gradient-default">
            <Container className="pt-lg pb-300">
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Join Our Journey</h2>
                  <p className="lead text-white">
                    We're always looking for talented individuals who share our passion 
                    for intelligent monitoring and making technology more accessible.
                  </p>
                  <div className="btn-wrapper mt-4">
                    <Button
                      className="btn-neutral btn-icon mb-3 mb-sm-0"
                      color="default"
                      tag={Link}
                      to="/contact"
                    >
                      <span className="btn-inner--icon">
                        <i className="fa fa-envelope" />
                      </span>
                      <span className="btn-inner--text">Contact Us</span>
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default About;
